var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 22,
    viewBox: "0 0 30 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gmail_icon_(2020) 1",
    clipPath: "url(#clip0_14084_12313)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.69318 21.7952H7.22727V10.6726L0.75 5.76562V19.8324C0.75 20.9185 1.62119 21.7952 2.69318 21.7952Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.7729 21.7952H27.307C28.3823 21.7952 29.2502 20.9152 29.2502 19.8324V5.76562L22.7729 10.6726",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M22.7729 2.1676V10.6731L29.2502 5.76608V3.149C29.2502 0.72166 26.5071 -0.662121 24.5866 0.79363",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M7.22705 10.6735V2.16797L14.9998 8.0564L22.7725 2.16797V10.6735L14.9998 16.5619",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M0.75 3.149V5.76608L7.22727 10.6731V2.1676L5.41364 0.79363C3.48989 -0.662121 0.75 0.72166 0.75 3.149Z",
    fill: "#C5221F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14084_12313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.5,
    height: 21.5909,
    fill: "white",
    transform: "translate(0.75 0.205078)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmailIcon);
export default __webpack_public_path__ + "static/media/gmail-icon.4d2dc62e86ae38d86b357cb6b90d5146.svg";
export { ForwardRef as ReactComponent };